// ── 페이지 번호 버튼 (2026-09-16) ─────────────────────────────────────────────
// 목록이 길 때 1·2·3… 으로 나눠 보는 공용 부품. 데이터는 호출부가 자른다(이 부품은 그리기만).
// 모양은 로그 관리의 페이지 버튼과 같은 값(검정 활성 + 흰 비활성).
//   ※ 로그 관리(BusinessLogTab·LeaveLogTab)에는 같은 모양이 각각 복사돼 있다. 그쪽은 서버에서 페이지를
//      받아 오는 구조라 이번 작업 범위 밖이라 두었다 — 나중에 이 부품으로 합칠 수 있다.

import React from 'react';

const wrapStyle = {
  display: 'flex', justifyContent: 'center', alignItems: 'center',
  gap: 6, flexWrap: 'wrap', marginTop: 16,
};

const btnStyle = (active, disabled) => ({
  minWidth: 32,
  padding: '5px 10px',
  border: `1px solid ${active ? 'var(--std-btn, #0f172a)' : 'var(--border)'}`,
  borderRadius: 8,
  background: active ? 'var(--std-btn, #0f172a)' : 'var(--bg-card)',
  color: active ? '#fff' : 'var(--text-sub)',
  fontSize: 12,
  fontWeight: active ? 700 : 500,
  cursor: disabled ? 'not-allowed' : 'pointer',
  opacity: disabled ? 0.45 : 1,
});

/**
 * @param {number} page        현재 페이지 (1부터)
 * @param {number} totalPages  전체 페이지 수
 * @param {(p:number)=>void} onMove
 * @param {number} [window=5]  한 번에 보여줄 번호 개수
 */
export default function Pagination({ page, totalPages, onMove, window: windowSize = 5 }) {
  if (!totalPages || totalPages <= 1) return null;
  // 현재 페이지가 가운데 오도록 번호 창을 잡되, 양 끝에서는 창 크기를 유지한다.
  const half = Math.floor(windowSize / 2);
  let start = Math.max(1, page - half);
  const end = Math.min(totalPages, start + windowSize - 1);
  start = Math.max(1, end - windowSize + 1);
  const numbers = [];
  for (let p = start; p <= end; p += 1) numbers.push(p);

  return (
    <div style={wrapStyle}>
      <button type="button" style={btnStyle(false, page <= 1)} disabled={page <= 1}
        onClick={() => onMove(page - 1)} aria-label="이전 페이지">이전</button>
      {numbers.map((p) => (
        <button key={p} type="button" style={btnStyle(p === page, false)}
          onClick={() => onMove(p)} aria-current={p === page ? 'page' : undefined}>{p}</button>
      ))}
      <button type="button" style={btnStyle(false, page >= totalPages)} disabled={page >= totalPages}
        onClick={() => onMove(page + 1)} aria-label="다음 페이지">다음</button>
    </div>
  );
}
